import { parseInt } from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import AbsencesGql from '@/store/graphql/system/queries/Absences.gql';
import VacationBalanceGql from '@/store/graphql/system/queries/VacationBalance.gql';
import PublicHolidaysGql from '@/store/graphql/system/queries/PublicHolidays.gql';
import AbsenceApprovalGql from '@/store/graphql/system/queries/AbsenceApproval.gql';
import SaveAbsenceGql from '@/store/graphql/system/mutations/SaveAbsence.gql';
import DeleteAbsenceGql from '@/store/graphql/system/mutations/DeleteAbsence.gql';
import DecideAbsenceGql from '@/store/graphql/system/mutations/DecideAbsence.gql';

const query = (document, variables) =>
    apolloClient.query({ query: document, variables, fetchPolicy: 'network-only' }).then(({ data }) => data);

const mutate = (document, variables) => apolloClient.mutate({ mutation: document, variables }).then(({ data }) => data);

export default {
    fetchAbsences: ({ from, to, userId, type, status }) =>
        query(AbsencesGql, {
            from,
            to,
            user_id: userId ? parseInt(userId) : undefined,
            type: type || undefined,
            status: status || undefined,
        }).then((data) => data.Absences || []),

    fetchBalance: ({ userId, year }) =>
        query(VacationBalanceGql, { user_id: parseInt(userId), year: parseInt(year) }).then((data) => data.VacationBalance),

    fetchPublicHolidays: (year) => query(PublicHolidaysGql, { year: parseInt(year) }).then((data) => data.PublicHolidays || []),

    fetchApproval: () => query(AbsenceApprovalGql, {}).then((data) => data.AbsenceApproval),

    saveAbsence: ({ id, absence }) =>
        mutate(SaveAbsenceGql, { id: id ? parseInt(id) : undefined, absence }).then((data) => data.SaveAbsence),

    deleteAbsence: (id) => mutate(DeleteAbsenceGql, { id: parseInt(id) }).then((data) => data.DeleteAbsence),

    decideAbsence: ({ id, status }) => mutate(DecideAbsenceGql, { id: parseInt(id), status }).then((data) => data.DecideAbsence),
};
